import { takeLatest } from "redux-saga/effects";
import { ActionType } from "./types/actionType";
import {
  handlePlaceOrder,
  handleUserLoggedIn,
  handleUserLoggedOut,
  handleUpdateActiveTab,
  handleAddSampleToCart,
  handleAddInfectiousAliquotToCart,
  handleRemoveProductFromCart,
  handlePresignedImageUrlRequest,
  handleRemoveAllProductFromCart,
} from './workers';

export function* watcher() {
  yield takeLatest(ActionType.USER_LOGGED_IN, handleUserLoggedIn);
  yield takeLatest(ActionType.USER_LOGGED_OUT, handleUserLoggedOut);
  yield takeLatest(ActionType.NAVIGATION_TAB_CLICKED, handleUpdateActiveTab);
  yield takeLatest(
    ActionType.ADD_SAMPLE_TO_CART_CLICKED,
    handleAddSampleToCart
  );
  yield takeLatest(
    ActionType.ADD_INFECTIOUS_ALIQUOT_TO_CART_CLICKED,
    handleAddInfectiousAliquotToCart
  );
  yield takeLatest(
    ActionType.REMOVE_PRODUCT_FROM_CART,
    handleRemoveProductFromCart
  );
  yield takeLatest(
    ActionType.REMOVE_ALL_PRODUCT_FROM_CART,
    handleRemoveAllProductFromCart
  );
  yield takeLatest(
    ActionType.PLACE_ORDER,
    handlePlaceOrder,
  );
  yield takeLatest(ActionType.PRESIGNED_IMAGE_URL_REQUESTED, handlePresignedImageUrlRequest);
}
